export const AnalyticsEvent = {
	EVENT_DOWNLOAD:  'event_download',
	MOMENT_DOWNLOAD: 'moment_download',
	MOMENT_CREATED:  'moment_created',
	EVENT_SHARE:     'event_share',
};
